<template>
  <div class="opera-huanqiu-ft" :class="fuckingBig ? 'fuckingBig' : ''">
    <!--    :title="'环球 ' + (!isMultSelect? $t('fangT_title'):mutlSelectTitle) + currentSelectedRoomStatus"-->
    <topNav ref="topnav"
            v-if="mihotelBinding"
            selfMethod="1"
            @leftClick="cancleSelect"
            :title="isMultSelect ? mutlSelectTitle : $t('fangT_title')"
            :selectMore="hasBindBuilding"
            :hideLeft="!fromBigToSmall"
            @goSelect="goSelect"
            @operateMultSelected="multRoomOperate"
            @cancleSelectMore="cancleSelectMore"></topNav>
    <div class="topHeader" v-else>
      <mt-header :title="$t('fangT_title')"
                 fixed
                 :style="{backgroundColor:'#393C41'}">
        <i class="mintui mintui-back"
           v-if="fromBigToSmall"
           @click="cancleSelect"
           slot="left"></i>
      </mt-header>
    </div>

    <template v-if="loaded">

      <template v-if="hasBindBuilding">
        <div class="fangt_top" v-show="!fromBigToSmall">
          <div class="search">
            <i class="iconfont icon-sousuo"></i>
            <input type="text" id='searchInput' x-webkit-speech v-model='searchOption.rmno' name=""
                   :placeholder="$t('fangT_rmno')">
            <div class="cleartext" @click="searchOption.rmno='';getData();" v-if="searchOption.rmno != ''">
              <i class="iconfont icon-cuowu"></i>
            </div>
            <div class="cleartext" v-else>
              <i class="iconfont icon-yuyin" @click="startRecognize"></i>
            </div>
          </div>
          <div class="searct_btn" @click='getData'>{{ $t('search') }}</div>
          <span class="line"></span>
          <mt-button @click.native="showFliter">
            <div class="fliter">{{ $t('fliter') }}
              <i class="iconfont icon-xia"></i>
            </div>
          </mt-button>
        </div>
        <div class="building-bar" v-show="!fromBigToSmall">
          <div class="building-bar-item"
               :class="{active: item.code == searchOption.buildings}"
               @click="chooseBarBuilding(item)"
               v-for="(item, index) in serchList.buildings">
            {{ item.descript }}
          </div>
        </div>
        <div style="height: 300px; overflow: scroll">
          <mt-loadmore
            :auto-fill="false"
            :top-method="loadTop"
            @top-status-change="handleTopChange"
            @bottom-status-change="handleBottomChange"
            :top-status.sync="topStatus"
            :bottom-status.sync="bottomStatus"
            :bottomDistance="150"
            :bottom-all-loaded="false"
            @bottom-method="loadBottom"
            ref="loadmore">
            <div class="all_ft" :class="{'mt-small': fromBigToSmall}">
              <div class="roomFloorList" v-for="(itemOut,indexOut) in buildRoomStatuInfos" :key="indexOut">
                <div class="room-floor-header">
                  {{ itemOut.build }} / {{ itemOut.floor }}
                  {{ searchOption.parentRmno && ('/' + searchOption.parentRmno) }}
                </div>
                <div class="roomListItem"
                     v-for='(item,key) in itemOut.roomStatuInfos'
                     @click='touchitem(item)'
                     :key="item.rmno + key"
                     :style='{background:item.color}'
                     :class="{'rightBorder':(key+1)% (fuckingBig ? 3 : 5) !=0}">
                  <span class="iconfont icon-mima" v-if="item.staTmp == 'true'"></span>
                  <p class="roomNo">
                    {{ item.rmno }}
                    <!--                                {{ staObj[item.sta] }}-->
                  </p>
                  <p class="roomType" :class="{'rms':item.rmTypeDes.length>6}">
                    {{ item.rmTypeDes }}
<!--                    {{item.reason}}-->
                  </p>
                  <span class="occ-num-list">
                    <span class="iconfont icon-wode" v-for="i in item.occNum"></span>
                  </span>

                  <div class="multChoice"
                       :class="{'choiced':item.choiced, 'deepBg': currentSelectedRoomStatus && !item.choiced && (item.sta != currentSelectedRoomStatus)}"
                       v-show="isMultSelect">
                    <div class="mult-cicle">
                      <i class="iconfont icon-right">
                      </i>
                    </div>
                  </div>
                </div>
              </div>

              <nothing :condition="buildRoomStatuInfos != null && buildRoomStatuInfos.length == 0"></nothing>
            </div>
            <div slot="top" class="mint-loadmore-top">
          <span v-show="topStatus !== 'loading'"
                :class="{ 'rotate': topStatus === 'drop' }"> ↓ {{ $t('index_refresh') }}</span>
              <span v-show="topStatus === 'loading'">Loading...</span>
            </div>
          </mt-loadmore>
        </div>

        <div class="fboot"></div>

        <div class="foot_ft">
          <div class="foot_c">
            <div style="width:37.5rem">
              <div class="top" :class='{checked:(item.staOcc==searchOption.staOcc) || (item.staOcc == "LOCK" && searchOption.staTmp == "true")}'
                   v-for='item in roomStatuOccStatisticItems'
                   :key="item.staOcc" @click='setStaOcc(item)'>
                <div class="cicle" :style="{background:item.color,borderColor:item.color}"></div>
                {{ item.staOccDesc }}({{ item.quailty }})
              </div>
            </div>
          </div>
          <div class="foot_d">
            <div class="clearfix flotwarp">
              <div class="bottom" v-for='item in roomStatuStatisticItems' @click='setSta(item)' :key="item.sta">
                <div class="checkbox" :class='{checked:item.sta==searchOption.sta}'>
                  <div class="dimetric" :style="{background:item.color,borderColor:item.color}">
                  </div>
                  {{ item.staDesc }}({{ item.quailty }})
                </div>
              </div>
            </div>
          </div>
        </div>
        <actionsheet :actions="actions" v-model="sheetVisible"></actionsheet>

        <mt-popup v-model="popupVisible3" position="right" @touchmove.stop class="mint-popup-3 rightFliterBox"
                  :modal="true">
          <div class="rightFliterBox">
            <div class="filter_title">
              <span class="title">{{ $t('fliter') }}</span>
              <mt-button @click.native="popupVisible3 = false">
                <i class="iconfont icon-cuowu"></i>
              </mt-button>
            </div>
            <!--        标准筛选条件-->
            <div class="fliter_item" v-for='(itemF,index) in rightList' :key="index"
                 v-if='!!serchList[itemF.node]&&serchList[itemF.node].length>1'>
              <div class="category_name">
                <span>{{ itemF.name }}</span>
                <p class="showCategory" @click='showmore(index)'
                   v-if='!!serchList[itemF.node]&&serchList[itemF.node].length>4'>{{ $t('all') }}
                  <i class="iconfont icon-xia2 " :class="{open:rightList[index].more=='T'}"></i>
                </p>
              </div>
              <div class="category_list clearfix" :class="{twocol:itemF.node!='building',show:itemF.more=='T'}">
                <div v-for='(item,itemkey) in serchList[itemF.node]' :key="itemkey">
                  <div class="option oplist" :class='{checked: includeOption(itemF.node, item.code)}'
                       @click='selectSelf(itemF.node,item)'>{{ item.descript }}
                  </div>
                </div>
              </div>
            </div>

            <!--       其他筛选条件 -->
            <div class="fliter_item" v-if="!!serchList['filter']&&serchList['filter'].length>0">
              <div class="category_name">
                <span>{{ $t('other') }}</span>
              </div>
              <div class="category_list clearfix twocol">
                <div v-for='(item,itemkey) in serchList["filter"]' :key="itemkey">
                  <div class="option oplist" :class='{checked:  includeOption("filterKey", item.code)}'
                       @click='selectSelf("filterKey",item)'>{{ item.descript }}
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom_f">
              <div class="reset" @click='reset'>{{ $t('reset') }}</div>
              <div class="success" @click='sendData'>{{ $t('complete') }}</div>
            </div>
          </div>
        </mt-popup>


        <mt-popup v-model="popupVisibleSta" position="bottom" class="checkOutPop" :modal="true">
          <div class="checkList mutlList">
            <label>{{ $t('fangT_rmno') }} :</label>{{ sheetTemp.rmno }}
          </div>
          <mt-radio :title="$t('fangT_staNew')"
                    :max="1" v-model="staNew" :options="stas">
          </mt-radio>
          <div class="popBottom">
            <div class="cCancle" @click='popupVisibleSta=false'>{{ $t('cancel') }}</div>
            <div class="cSure" @click="updateSta">{{ $t('determine') }}</div>
          </div>
        </mt-popup>
      </template>
      <template v-else>
        <div class="building-init">
          <div class="bind-title">
            请绑定楼栋
          </div>
          <div class="bind-build-list">
            <div class="bind-build-item"
                 :class="{active: item.isActive}"
                 @click="selectBindBuild(item)"
                 v-for="(item, index) in allBuildings">
              {{ item.descript }}
            </div>
          </div>
          <div class="bind-build-btn" @click="confirmBindBuilding">
            确定绑定
          </div>
        </div>
      </template>
    </template>
    <foot-nav sta='2'></foot-nav>
  </div>
</template>
<script>
  import _ from "lodash";
  import {Actionsheet, Radio, Toast, MessageBox, Picker} from "mint-ui";
  import nothing from "../operaCommon/nothing";
  import moment from "moment";
  import footNav from "../operaCommon/huanQiufootNav";

  export default {
    data() {
      return {
        fuckingBig: localStorage.getItem('fuckingBig') == 'yes',
        loaded: false,
        mutlSelectTitle: this.$t('fangT_mutlSelectTitle'),
        // //       占用状态：OCC （占用） VAC （空闲）
        staOccObj: {
          OCC: '占用',
          VAC: '空闲',
        },

        // 房态：DI（脏房）  IP（检查） OO（大修） CL（干净） OS（小修）
        staObj: {
          DI: '脏房',
          IP: '检查',
          OO: '大修',
          CL: '干净',
          OS: '小修',
        },

        buildRoomStatuInfos: [],
        roomStatuOccStatisticItems: [],
        roomStatuStatisticItems: [],

        roomList: [],
        serchList: [],
        popupVisible3: false,
        popupFootVisible: false,
        rightList: [
          // 大小房态查看
          {
            name: this.$t('fangT_category_name'),
            node: "mode",
            more: "F"
          },
          //楼栋
          {
            name: this.$t("fangT_building"),
            node: "buildings",
            more: "F"
          },
          //楼层
          {
            name: this.$t("fangT_floor"),
            node: "floors",
            more: "F"
          },
          //房型
          {
            name: this.$t("fangT_rmtype"),
            node: "rmtypes",
            more: "F"
          },
          //特征
          {
            name: this.$t("fangT_feature"),
            node: "features",
            more: "F"
          }
        ],
        searchOption: {
          mode: "T", //大小房态查看 大房态 T，小房态 F
          rmno: "",
          filterKey: "",
          buildings: "",
          rmtypes: "",
          floors: "",
          features: "",
          sta: '',
          staOcc: '',
          parentRmno: '', // 通过大房号，来查询小房号
          rsvSta: '', // TODO 查询今日将到DUEIN, 将离 DUEOUT
        },
        stas: [
          {label: this.$t("fangT_RoomStaI"), value: "INSPECTED"}, // 检查
          {label: this.$t('fangT_RoomStaPU'), value: "PICKUP"}, // 小修
          {label: this.$t("fangT_RoomStaR"), value: "CLEAN"}, // 干净
          {label: this.$t("fangT_RoomStaD"), value: "DIRTY"} // 脏房
        ],
        popupVisibleSta: false,
        staNew: "",
        topStatus: "",
        bottomStatus: "",
        sheetTemp: {},
        sheetVisible: false,
        actions: [],
        isMultSelect: false,//是否是多选状态
        currentSelectedRoomArr: [],
        fromBigToSmall: false,
        currentSelectedRoomStatus: '',
        mostBuild: 5, // 小房态最多查询多少栋楼
        lastBuilding: '',

        // 判断是否有绑定过楼层
        hasBindBuilding: false,
        allBuildings: [],
        lastBindBuild: [], // 上次绑定过的楼层
        selectedBindBuildings: [],
        selectedBindBuildingsCodes: '',

        // 管理员登录
        mihotelBinding: localStorage.getItem('mihotelBinding') == 'yes',
        oldSta: '', // 老房态
        isLock: false, // 是否锁定
      };
    },
    mounted() {
      if (localStorage.getItem('mihotelBinding') == 'yes') { // 管理员登录，就显示所有数据
        this.hasBindBuilding = true
        this.getFilter('no', 'yes')
        this.loaded = true
      } else {
        this.getBindBuilding()
      }
    },
    methods: {
      // 查询之前绑定的楼栋
      getBindBuilding() {
        this.$http
          .post("/mobilepmsapi/opera/biz/selectRoomInfoById")
          .then(res => {
            if (res.data.result == 0) {
              var retVal = res.data.retVal || {}
              var bindBuildings = retVal.bindBuildings || ''
              // 如果之前有绑定过，直接用绑定过的数据去查询
              if (bindBuildings) {
                this.lastBindBuild = bindBuildings.split(',') || []
                this.getFilter('no', 'yes', 'yes');
              } else {
                this.hasBindBuilding = false
                this.getFilter('no', 'no');
              }
            } else {
              this.msg(res.data.msg);
            }
          });
      },

      selectBindBuild(build) {
        if (!build.isActive && this.selectedBindBuildings.length > 4) {
          this.msg('最多只能绑定5个楼栋')
        } else {
          build.isActive = !build.isActive
          var includeFlag = false
          var includeIndex = ''
          this.selectedBindBuildings.map((item, index) => {
            if (build.code == item.code) {
              includeFlag = true
              includeIndex = index
            }
          })
          if (includeFlag) {
            this.selectedBindBuildings.splice(includeIndex, 1)
          } else {
            this.selectedBindBuildings.push(build)
          }
          this.$forceUpdate()
        }
      },

      confirmBindBuilding() {
        const self = this
        if (this.selectedBindBuildings && this.selectedBindBuildings.length > 0) {
          MessageBox.confirm('确定绑定这些楼栋吗?')
            .then(action => {
              if (action == 'confirm') {
                self.doBindBuilding()
              }
            })
        } else {
          self.msg('请选择要绑定的楼栋')
        }
      },

      doBindBuilding() {
        const self = this
        var selectedBindBuildings = self.selectedBindBuildings || []
        var codes = _.map(selectedBindBuildings, 'code')
        var codeStr = codes.join(',') || ''
        let LoginOptionStr = localStorage.getItem('LoginOption') || ''
        let LoginOption = JSON.parse(LoginOptionStr || "{}")
        let userName = LoginOption.username || ''

        this.$http.post("/mobilepmsapi/opera/biz/saveRoomInfoForHuanQiu", {
          bindBuildings: codeStr,
          mac: localStorage.getItem('hbuilderXNewUUID') || 'no mac',
          oldValue: '',
          newValue: codeStr,
          operateItem: userName,
        }).then(res => {
          if (res.data.result == 0) {
            this.msg('楼栋绑定成功');
            this.bindBuildNext()
          } else {
            this.msg(res.data.msg);
          }
        });
      },

      bindBuildNext() {
        const self = this
        self.serchList.buildings = self.selectedBindBuildings
        self.searchOption.buildings = self.selectedBindBuildings[0].code
        self.getData()
        self.hasBindBuilding = true
      },

      chooseBarBuilding(item) {
        this.searchOption.buildings = item.code
        this.getData()
      },
      cancleSelect() {
        if (this.fromBigToSmall) {
          this.searchOption = {
            mode: "T", //大小房态查看 大房态 T，小房态 F
            rmno: "",
            filterKey: "",
            buildings: this.lastBuilding,
            rmtypes: "",
            floors: "",
            features: "",
            sta: '',
            staOcc: '',
            parentRmno: '', // 通过大房号，来查询小房号
          }
          this.fromBigToSmall = false
          this.getData()
        } else {
          this.$router.push('/opera/indexHuanQiu')
        }
      },
      includeOption(searchType, searchCode) {
        var flag = false
        if (this.searchOption && this.searchOption[searchType]) {
          let temp = this.searchOption[searchType].split(',')
          if (temp.indexOf(searchCode) > -1) {
            flag = true
          }
        }
        return flag
      },
      startRecognize() {
        var options = {engine: "iFly", punctuation: false};
        this.searchOption.rmno = '';
        var that = this;
        plus.speech.startRecognize(options, function (s) {
          that.searchOption.rmno = _.trim(s);
          that.getData();
        }, function (e) {
          that.msg2(this.$t("msg_recognize_fail") + e.message);
        });
      },
      showFliter() {
        if (this.serchList.length == undefined) {
          this.popupVisible3 = true;
          return;
        }
        this.getFilter('yes', 'yes')
      },
      getFilter(showFilter, setFirst, useLastBuild) {
        const self = this
        this.$http
          .post("/mobilepmsapi/opera/biz/getRoomStatusFilterHuanQiu")
          .then(res => {
            if (res.data.result == 0) {
              let list = res.data.retVal || []
              list.mode = [{
                descript: this.$t('fangT_villadataB'),
                code: 'T'
              }, {
                descript: this.$t('fangT_villadataS'),
                code: 'F'
              }]
              this.serchList = res.data.retVal;
              this.allBuildings = this.serchList.buildings || []

              if (showFilter == 'yes') {
                this.popupVisible3 = true;
              }

              // 使用之前绑定过的楼栋
              if (useLastBuild == 'yes') {
                var lastBindBuild = this.lastBindBuild || []
                var tempBuildArr = []
                console.log('lastBindBuild', lastBindBuild)
                lastBindBuild.map((item, index) => {
                  self.allBuildings.map((item2, index2) => {
                    if (item2.code == item) {
                      tempBuildArr.push(item2)
                    }
                  })
                })
                self.serchList.buildings = tempBuildArr || []
                this.hasBindBuilding = true
              }

              // 默认选中第一栋楼
              if (setFirst == 'yes') {
                var buildings = this.serchList.buildings || []
                if (buildings.length) {
                  this.searchOption.buildings = buildings[0].code
                }
                this.getData();
              }
              this.loaded = true
            } else {
              this.msg(res.data.msg);
            }
          });
      },
      openPick(p) {
        this.$refs[p].open();
      },
      updateSta() {
        let multChoicedArr = this.currentSelectedRoomArr || []
        console.log('multChoicedArr: ', multChoicedArr)
        this.$http
          .post("/mobilepmsapi/opera/biz/updateRoomSta", {
            sta: this.staNew,
            rmno: this.sheetTemp.rmno,
            mac: localStorage.getItem('hbuilderXNewUUID') || 'no mac',
            oldValue: this.oldSta,
            newValue: this.staNew,
            operateItem: this.sheetTemp.rmno,
          })
          .then(res => {
            this.popupVisibleSta = false;
            if (res.data.result == 0) {
              this.msg(this.$t('msg_update_success'));
              this.isMultSelect = false
              this.$refs.topnav.selectMoreing = false
              this.currentSelectedRoomArr = []
              this.currentSelectedRoomStatus = ''
              this.getData();
            } else {
              this.msg(res.data.msg);
            }
          });
      },

      geturl() {
        if (this.$route.query.redirect != null) {
          return this.$route.query.redirect;
        }
        return "/";
      },
      msg(msg) {
        Toast({
          message: msg,
          position: "bottom",
          duration: 3000
        });
      },
      showFoot() {
        this.popupFootVisible = !this.popupFootVisible;
      },
      getData() {
        this.currentSelectedRoomArr = []
        this.currentSelectedRoomStatus = ''
        if (this.isMultSelect) {
          this.mutlSelectTitle = this.fangT_mutlSelectTitleText + ' ' + this.currentSelectedRoomArr.length + ' ' + this.$t("fangT_mutlSelectTitUnit")
        }

        this.$http
          .post("/mobilepmsapi/opera/biz/getRoomStatusForHuanQiu", this.searchOption)
          .then(res => {
            if (res.data.result == 0) {
              var obj = res.data.retVal || {}
              var resultInfo = obj.resultInfo || {}
              this.buildRoomStatuInfos = resultInfo.buildRoomStatuInfos || [];
              this.roomStatuOccStatisticItems = resultInfo.roomStatuOccStatisticItems || [];
              this.roomStatuStatisticItems = resultInfo.roomStatuStatisticItems || [];
            } else {
              this.msg(res.data.msg);
            }
          });
      },

      goFangTXQ() {
        this.$router.push("/opera/orderDetail?rsvNo=" + this.sheetTemp.id + "&redirect=/opera/fangTHuanQiu&viewType=HuanQiu");
      },

      updateToLock() {
        this.isLock = true;
        let msg = ''
        if (this.sheetTemp.rmno && this.sheetTemp.rmno.indexOf(',') > -1) {
          msg = '确定把房间锁定吗'
        } else {
          msg = this.$t('fangT_sure_prev') + this.sheetTemp.rmno + '锁定吗'
        }
        MessageBox.confirm(msg)
          .then(action => {
            if (action == 'confirm') {
              this.updateLockStatus()
            }
          })
      },

      updateToUnlock() {
        this.isLock = false;
        let msg = ''
        if (this.sheetTemp.rmno && this.sheetTemp.rmno.indexOf(',') > -1) {
          msg = '确定把房间解锁吗'
        } else {
          msg = this.$t('fangT_sure_prev') + this.sheetTemp.rmno + '解锁吗'
        }
        MessageBox.confirm(msg)
          .then(action => {
            if (action == 'confirm') {
              this.updateLockStatus()
            }
          })
      },

      updateLockStatus() {
        let multChoicedArr = this.currentSelectedRoomArr || []
        console.log('multChoicedArr: ', multChoicedArr)
        var isLock = this.isLock
        this.$http
          .post("/mobilepmsapi/opera/biz/updateRoomSta", {
            sta: this.isLock ? 'true' : 'false',
            rmno: this.sheetTemp.rmno,
            mac: localStorage.getItem('hbuilderXNewUUID') || 'no mac',
            oldValue: isLock ? '解锁' : '锁定',
            newValue: isLock ? '锁定' : '解锁',
            operateItem: this.sheetTemp.rmno,
          })
          .then(res => {
            this.popupVisibleSta = false;
            if (res.data.result == 0) {
              this.msg(this.$t('msg_update_success'));
              this.isMultSelect = false
              this.$refs.topnav.selectMoreing = false
              this.currentSelectedRoomArr = []
              this.currentSelectedRoomStatus = ''
              this.getData();
            } else {
              this.msg(res.data.msg);
            }
          });
      },

      updateRoomStaR() {
        this.staNew = "CLEAN";
        let msg = ''
        if (this.sheetTemp.rmno && this.sheetTemp.rmno.indexOf(',') > -1) {
          msg = '确定修改房态为干净吗'
        } else {
          msg = this.$t('fangT_sure_prev') + this.sheetTemp.rmno + this.$t('fangT_sure_clean')
        }
        MessageBox.confirm(msg)
          .then(action => {
            if (action == 'confirm') {
              this.updateSta()
            }
          })
      },

      updateRoomStaD() {
        this.staNew = "DIRTY";
        let msg = ''
        if (this.sheetTemp.rmno && this.sheetTemp.rmno.indexOf(',') > -1) {
          msg = '确定修改房态为脏房吗'
        } else {
          msg = this.$t('fangT_sure_prev') + this.sheetTemp.rmno + this.$t('fangT_sure_dirty')
        }
        MessageBox.confirm(msg)
          .then(action => {
            if (action == 'confirm') {
              this.updateSta()
            }
          })
      },

      updateRoomStaIS() {
        this.staNew = "INSPECTED";
        let msg = ''
        if (this.sheetTemp.rmno && this.sheetTemp.rmno.indexOf(',') > -1) {
          msg = '确定修改房态为检查吗'
        } else {
          msg = this.$t('fangT_sure_prev') + this.sheetTemp.rmno + this.$t('fangT_sure_inspected')
        }
        MessageBox.confirm(msg)
          .then(action => {
            if (action == 'confirm') {
              this.updateSta()
            }
          })
      },
      setStaOcc(item) {
        if(item.staOcc == 'LOCK'){ // 查询锁定房
          if(this.searchOption.staTmp == 'true'){
            this.searchOption.staTmp = ''
          } else {
            this.searchOption.staTmp = 'true'
          }
        } else {
          if (item.staOcc == this.searchOption.staOcc) {
            this.searchOption.staOcc = "";
          } else {
            this.searchOption.staOcc = item.staOcc;
          }
        }
        this.getData();
      },
      setSta(item) {
        if (item.sta == this.searchOption.sta) {
          this.searchOption.sta = "";
        } else {
          this.searchOption.sta = item.sta;
        }
        this.getData();
      },
      reset() {
        _.map(this.searchOption, (value, key) => {
          this.searchOption[key] = "";
        });
        this.searchOption.mode = 'T'
        this.searchOption.parentRmno = ''
        // 默认选中第一栋楼
        var buildings = this.serchList.buildings || []
        if (buildings.length) {
          this.searchOption.buildings = buildings[0].code
        }
        this.getData()
      },
      handleTopChange: function (status) {
        this.topStatus = status;
      },
      handleBottomChange: function (status) {
        console.log('handleBottomChange fuck', status)
        this.bottomStatus = status;
      },
      loadTop() {
        console.log('loadTop')
        this.getData();
        this.$refs.loadmore.onTopLoaded();
      },

      loadBottom() {
        // alert('loadBottom')
        // this.allLoaded = true;// if all data are loaded
        this.$refs.loadmore.onBottomLoaded();
      },

      sendData() {
        if (this.searchOption.mode == 'F' && !this.searchOption.buildings) {
          // this.msg('查询小房态时请先选择楼栋')
          this.msg(this.$t('fangT_sure_small_build'))
        } else {
          this.popupVisible3 = false;
          this.getData();
        }
      },

      selectSelf(node, item) {
        if (node == 'mode') { // 选大小房, 大小房只能必选
          this.searchOption[node] = item.code;
          if (item.code == 'T') {
            this.searchOption.parentRmno = ''
          }
        } else {
          var temp = this.searchOption[node] || ''
          var tempArr = []
          if (temp) {
            tempArr = temp.split(',')
          }

          // 小房态查询，必须选楼栋，并且最多选3栋楼
          if (node == 'buildings') {
            tempArr = [item.code]
          } else {
            if (tempArr.indexOf(item.code) > -1) {
              tempArr.splice(tempArr.indexOf(item.code), 1);
            } else {
              tempArr.push(item.code)
            }
          }
          this.searchOption[node] = tempArr.join(',')
        }
      },
      showmore(item) {
        this.rightList[item].more = this.rightList[item].more == "T" ? "F" : "T";
      },

      touchitem(item) {
        if (this.isMultSelect) {//多选状态下
          if (!this.currentSelectedRoomStatus || (this.currentSelectedRoomStatus == item.sta)) {
            this.currentSelectedRoomStatus = item.sta
            this.$set(item, "choiced", !item.choiced)
            if (this.currentSelectedRoomArr && this.currentSelectedRoomArr.indexOf(item.rmno) > -1) {
              this.currentSelectedRoomArr.splice(this.currentSelectedRoomArr.indexOf(item.rmno), 1);
            } else {
              this.currentSelectedRoomArr.push(item.rmno)
            }
            console.log(this.currentSelectedRoomArr)
            if (this.currentSelectedRoomArr.length == 0) {
              this.currentSelectedRoomStatus = ''
            }
            this.mutlSelectTitle = this.fangT_mutlSelectTitleText + ' ' + this.currentSelectedRoomArr.length + ' ' + this.$t("fangT_mutlSelectTitUnit")
          } else {
            // this.msg('不能同时选择状态不一样房间')
            this.msg(this.$t('fangT_sure_same_status'))
          }
        } else {
          this.goToFangTXQ(item)
        }
      },
      goToFangTXQ(item) {
        var sheetTemp = {
          rmno: item.rmno,
          rmtype: item.rmtype,
          pushWxRightroomSta: item.roomSta
        };
        if (item.guest && item.guest.length) {
          sheetTemp.id = item.guest[0].reservationId || ''
        }
        this.sheetTemp = sheetTemp
        this.pushBtns(item);
      },

      viewSmallFT() {
        this.lastBuilding = this.searchOption.buildings
        this.searchOption = {
          mode: "F", //大小房态查看 大房态 T，小房态 F
          rmno: "",
          filterKey: "",
          buildings: "",
          rmtypes: "",
          floors: "",
          features: "",
          sta: '',
          staOcc: '',
          parentRmno: this.sheetTemp.rmno || '' // 通过大房号，来查询小房号
        }
        this.fromBigToSmall = true
        this.getData()
      },

      pushBtns(item) {
        this.actions = [];
        if (this.searchOption.mode == 'T') { // 大房态点击查看看小房态
          this.actions.push({name: this.$t('fangT_sure_check_small') || this.$t('view'), method: this.viewSmallFT});
        }
        this.setBtns(item.sta, item.reason)
      },

      multRoomOperate() {
        let multChoicedArr = this.currentSelectedRoomArr || []
        if (multChoicedArr.length == 0) {
          this.msg(this.msg_choose_room)
          return;
        }
        this.sheetTemp = {
          rmno: multChoicedArr.join(',')
        }
        this.actions = [];
        var sta = this.currentSelectedRoomStatus || ''
        this.setBtns(sta)
      },

      setBtns(sta, reason) {
        // staObj: {
        //   DI: '脏房',
        //     IP: '检查',
        //     CL: '干净',
        // },
        this.oldSta = sta
        if(reason){
          this.actions.push({
            name: '锁房理由：' + reason
          });
        }
        if (sta == "DI") { // 脏房，只能变成干净
          this.actions.push({name: this.fangT_RoomStaR, method: this.updateRoomStaR});
        } else if (sta == "IP") { // 检查，变成干净、脏房
          if(this.mihotelBinding){
            this.actions.push({name: this.fangT_RoomStaD, method: this.updateRoomStaD});
            this.actions.push({name: this.fangT_RoomStaR, method: this.updateRoomStaR});
          }
        } else if (sta == "CL") { // 干净，变成 脏房、检查
          this.actions.push({name: this.fangT_RoomStaD, method: this.updateRoomStaD});
          if(this.mihotelBinding){
            this.actions.push({name: this.$t('fangT_RoomStaI'), method: this.updateRoomStaIS});
          }
        }

        // if(!this.fromBigToSmall){
        //   this.actions.push({name: '锁定', method: this.updateToLock});
        //   this.actions.push({name: '解锁', method: this.updateToUnlock});
        // }

        if (this.actions.length) {
          this.sheetVisible = true;
        }
      },

      cancleSelectMore() {
        this.isMultSelect = false
        this.mutlSelectTitle = this.fangT_mutlSelectTitle;
        this.currentSelectedRoomArr = []
        this.currentSelectedRoomStatus = ''
        _.map(this.buildRoomStatuInfos, (item, index) => {
          _.map(item.roomStatuInfos, (val, key) => {
            if (val.choiced) {
              val.choiced = false
            }
          })
        })
      },
      goSelect() {
        this.isMultSelect = true
        this.currentSelectedRoomArr = []
        this.currentSelectedRoomStatus = ''
      },
    },
    computed: {
      msg_choose_reason() {
        return this.$t("msg_choose_reason");
      },
      msg_update_success() {
        return this.$t("msg_update_success");
      },
      msg_choose_room() {
        return this.$t("msg_choose_room");
      },

      fangT_mutlSelectTitle() {
        return this.$t("fangT_mutlSelectTitle");
      },
      fangT_mutlSelectTitleText() {
        return this.$t("fangT_mutlSelectTitleText");
      },
      fangT_mutlSelectTitUnit() {
        return this.$t("fangT_mutlSelectTitUnit");
      },
      fangT_view() {
        return this.$t("fangT_view");
      },
      fangT_RoomStaR() {
        return this.$t("fangT_RoomStaR");
      },
      fangT_RoomStaD() {
        return this.$t("fangT_RoomStaD");
      },
      fangT_reserveBook() {
        return this.$t("fangT_reserveBook");
      },
      fangT_walkBook() {
        return this.$t("fangT_walkBook");
      },
      fangT_RoomStaOOO() {
        return this.$t("fangT_RoomStaOOO");
      },
      fangT_RoomStaOOS() {
        return this.$t("fangT_RoomStaOOS");
      },
      fangT_unRepair() {
        return this.$t("fangT_unRepair");
      },

      hasSelectFilter: function () {
        let flag = false
        let searchOption = this.searchOption || {}
        for (var key in searchOption) {
          if (key != 'rmno' && key != 'villa' && searchOption[key]) {
            flag = true
          }
        }
        return flag
      }
    },
    filters: {
      fdate(value) {
        return moment(value).format("YYYY-MM-DD");
      }
    },
    components: {
      actionsheet: Actionsheet,
      nothing,
      footNav
    }
  };
</script>
<style lang='less' scoped>
.topHeader {
  height: 1.04rem;

  .mint-header {
    color: #fff;
    font-size: 16px;
    top: -1px;
    padding: 0;
    z-index: 100;

    .leftMore,
    .rightMore {
      padding: 0 0.2rem;
      font-size: 14px;
    }
  }

  .mintui-back {
    line-height: 0.853333rem;
    padding: 0.2rem;
  }

  &.hideLeft{
    .mintui-back {
      display: none;
    }
  }

  .mint-button {
    padding: 0 0.2rem;
  }
}
  .opera-huanqiu-ft {
    height: 100%;

    .building-init {
      padding-top: 15px;
      padding-bottom: 15px;

      .bind-title {
        font-size: 16px;
        text-align: center;
      }

      .bind-build-list {
        padding: 15px 5%;
        box-sizing: border-box;
        text-align: center;

        .bind-build-item {
          display: inline-block;
          border: 1px solid #ddd;
          padding: 10px 20px;
          box-sizing: border-box;
          border-radius: 5px;
          margin-bottom: 10px;
          text-align: center;
          width: 25%;
          margin-right: 5px;

          &:nth-child(3n) {
            margin-right: 0;
          }

          &:active {
            background: #ddd;
          }

          &.active {
            background: orange;
            border: 1px solid orange;
          }
        }
      }

      .bind-build-btn {
        width: 60%;
        margin: 0 auto;
        text-align: center;
        padding: 10px 30px;
        border-radius: 10px;
        box-sizing: border-box;
        border: 1px solid #aaa;
        font-size: 15px;

        &:active {
          background: #ddd;
        }
      }
    }

    .occ-num-list {
      padding-left: 8px;
      font-size: 0;

      .iconfont {
        font-size: 14px;
        color: #333;
        display: inline-block;
      }
    }

    .roomFloorList {
      display: inline-block;
      width: 100%;
      border-bottom: 1px solid #eee;

      .room-floor-header {
        color: #b2b5c0;
        padding: 8px 15px;
        font-size: 16px;
      }

      .room-item {
        width: 2rem;
        height: 2rem;
        position: relative;
        top: 0.02666667rem;
        float: left;
        background: #caaf61;

        .item {
          border-bottom: 1px solid #fff;
          box-sizing: border-box;
          height: 100%;
          width: 100%;
          background-color: #00cfcf;
          overflow: hidden;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          position: relative;

          &.rightBorder {
            border-right: 1px solid #fff;
          }

          p {
            text-align: center;
            color: #333;
            margin: 0;
          }

          .roomNo {
            font-size: 0.32rem;
            height: 0.6rem;
            line-height: 0.6rem;
          }

          .roomType {
            box-sizing: border-box;
            padding: 0 0.06666667rem;
            font-size: 0.33333333rem;
            line-height: 0.66666667rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .rms {
            font-size: 0.25rem
          }

          .multChoice {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, .3);

            .mult-cicle {
              display: none;
              position: absolute;
              border-radius: 50%; // border: 1px #f7f8fa solid;
              box-sizing: border-box; // background: rgba(249, 143, 66, 0.4);
              background: #1470df;
              right: 7px; // left: 0;
              // top: 0;
              bottom: 7px; // margin: ~"calc(50% - 10px)" auto 0;
              width: 20px;
              height: 20px;
              text-align: center;
            }

            &.choiced {
              background-color: rgba(0, 0, 0, 0);

              .mult-cicle {
                display: block;

                .iconfont {
                  text-align: center;
                  line-height: 20px;
                  color: #fff;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }

    .building-bar {
      height: 1rem;
      background: #eee;
      box-sizing: border-box;
      position: fixed;
      top: 2.3rem;
      left: 0;
      z-index: 999;
      width: 100%;
      overflow-x: scroll;
      white-space: nowrap;

      .building-bar-item {
        display: inline-block;
        height: 1rem;
        line-height: 1rem;
        padding: 0 20px;
        text-align: center;
        border-right: 1px solid #fff;
        box-sizing: border-box;
        width: 18%;

        &.active {
          color: #4697fe;
          border-bottom: 3px solid #4697fe;
        }
      }
    }

    .fangt_top {
      height: 1.26666667rem;
      width: 10rem;
      background: #fff;
      padding: 0.18666667rem 0;
      box-sizing: border-box;
      position: absolute;
      top: 1.04rem;
      left: 0;
      z-index: 999;

      .mintui-back {
        font-size: 0.7rem;
        line-height: 0.853333rem;
        color: #c3c3c3;
      }

      .search {
        margin-left: 0.14rem;
        border-radius: 0.44rem;
        width: 6.1rem;
        float: left;
        height: 0.85333333rem;
        background-color: #f7f8fa;
        padding: 0 0.26666667rem;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        i.icon-sousuo {
          vertical-align: bottom;
          font-size: 0.42666667rem;
          color: #ccc;
          line-height: 0.89333333rem;
        }

        input {
          padding-left: 0.2rem;
          width: 3.28rem;
          vertical-align: middle;
          //margin-bottom: 0.13333rem;
          flex: 1;
          height: 0.62666667rem;
          background-color: #f7f8fa;
          outline: 0;
          border: 0;
        }

        .cleartext {
          float: right;

          i.icon-cuowu {
            line-height: 0.32rem;
            background-color: #c3c3c3;
            border-radius: 50%;
            font-size: 0.32rem;
            text-align: center;
            color: #fff;
            padding: 0.13333333rem;
            margin-top: 0.13333333rem;
            -webkit-transform-origin-x: 0;
            transform: scale(0.6);
            -webkit-transform: scale(0.6);
            width: 0.32rem;
            display: inline-block;
          }

          i.icon-yuyin {
            line-height: 0.85333333rem;
            font-size: 0.5rem;
            color: #999;
            text-align: center;
            padding-right: 0.13333333rem;
            display: inline-block;
          }
        }
      }

      .searct_btn {
        width: 1.73333333rem;
        box-sizing: border-box;
        text-align: left;
        float: left;
        height: 100%;
        font-size: 0.32rem;
        line-height: 0.89333333rem;
        color: #5b5b5b;
        padding-left: 0.33333333rem;
      }

      .line {
        float: left;
        width: 0.02666667rem;
        height: 0.53333333rem;
        background-color: #ccc;
        margin-top: 0.21333333rem;
      }

      .mint-button {
        height: 100%;
        background: #fff;
        box-shadow: none;
        padding: 0;

        .fliter {
          width: 1.86666667rem;
          float: left;
          font-size: 0.32rem;
          line-height: 0.89333333rem;
          text-align: right;
          box-sizing: border-box;
          color: #5b5b5b;

          .iconfont {
            display: inline-block;
            margin-left: 0.13333333rem;
          }
        }
      }
    }

    .all_ft {
      width: 100%;
      margin-top: 3.5rem;
      padding-bottom: 3.5rem;

      &.mt-small {
        margin-top: 1.1rem;
      }

      .fcolor {
        .roomNo,
        .roomType {
          color: #000 !important;
        }
      }


      .roomListItem {
        width: 2rem;
        height: 2rem;
        position: relative;
        background: #aaa;
        top: 0.02666667rem;
        float: left;
        border-bottom: 1px solid #fff;
        box-sizing: border-box;
        overflow: hidden;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        padding-top: 3px;

        .icon-mima {
          position: absolute;
          top: 8px;
          left: 3px;
          font-size: 12px;
        }

        &.rightBorder {
          border-right: 1px solid #fff;
        }

        .icon-peopleb2ren, .icon-renyuandingwei {
          position: absolute;
          color: #444;
          font-size: .32rem;
          top: 2px;
          line-height: 0.5rem;
          right: 0;

        }

        p {
          text-align: center;
          color: #333;
          margin: 0;
        }

        .roomNo {
          font-size: 0.32rem;
          height: 0.6rem;
          line-height: 0.6rem;
        }

        .roomType {
          box-sizing: border-box;
          padding: 0 0.06666667rem;
          font-size: 0.33333333rem;
          line-height: 0.66666667rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .rms {
          font-size: 0.25rem
        }

        .multChoice {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, .3);

          .mult-cicle {
            display: none;
            position: absolute;
            border-radius: 50%; // border: 1px #f7f8fa solid;
            box-sizing: border-box; // background: rgba(249, 143, 66, 0.4);
            background: #1470df;
            right: 7px; // left: 0;
            // top: 0;
            bottom: 7px; // margin: ~"calc(50% - 10px)" auto 0;
            width: 20px;
            height: 20px;
            text-align: center;
          }

          &.choiced {
            background-color: rgba(0, 0, 0, 0);

            .mult-cicle {
              display: block;

              .iconfont {
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 14px;
              }
            }
          }

          &.deepBg {
            background-color: rgba(0, 0, 0, 0.6);
          }
        }
      }
    }

    .foot_ft {
      box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
      width: 100%;
      position: absolute;
      bottom: 1.1733rem;
      padding: 0 0.18666667rem;
      box-sizing: border-box;
      background-color: #fff;

      .footPop {
        width: ~"calc(100% - .9rem)";
        left: ~"calc(50% - .5rem)";
        box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
        opacity: 1;
      }

      .foot_c {
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        padding: 8px 0;
        box-sizing: border-box;
        overflow-y: hidden;
        overflow-x: auto;

        .top {
          margin-top: 0.1rem; // margin-left: 0.36rem;
          margin-right: 0.15rem;
          float: left;
          text-align: left;
          color: #333; // padding: 0.05333333rem 0;
          padding: 0.1rem 0.1867rem;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .cicle {
            width: 0.33333333rem;
            height: 0.33333333rem;
            margin-right: 0.08rem;
            margin-top: -0.04rem;
            float: left;
            border-radius: 50%;
            border: 1px solid #969696;
            vertical-align: middle;
            position: relative;

            .iconfont {
              text-align: center;
              line-height: 0.30rem;
              vertical-align: text-top;
              font-size: 0.30rem;
              color: #333;
            }

          }
        }

        .checked {
          background: #f98f3c;
          border-radius: 0.26666667rem;
          padding: 0.1rem 0.1867rem;
          color: #fff;

          .cicle {
            border: none;
            background: #52c3f3; //   border: 1px solid #969696;
            margin-top: 0px;
          }
        }
      }

      .foot_d {
        background-color: #fff;
        width: 100%;
        padding: 8px 0;
      }

      .flotwarp {
        .bottom {
          height: 100%;
          width: 30%;
          display: inline-block;
          color: #333;
          margin: 3px 0;
          box-sizing: border-box;
          -webkit-tap-highlight-color: transparent;
          -webkit-user-select: none;
          -moz-user-focus: none;
          -moz-user-select: none;

          .checkbox {
            display: inline-block;
            padding: 0.1rem 0.1867rem;
            text-align: center;

            &.checked {
              background: #f98f3c;
              border-radius: 0.26666667rem;
              color: #fff;
            }

            .dimetric {
              width: 0.33333333rem;
              height: 0.33333333rem;
              margin-right: 0.08rem;
              float: left;
              border-radius: 0.1rem;
              border: 1px solid #969696;
              background: #fff;
              position: relative;

              .iconfont {
                color: #333;
                text-align: center;
                line-height: 0.30rem;
                vertical-align: text-top;
                font-size: 0.30rem;
              }
            }
          }

          .change {
            width: 33.3%;
          }
        }
      }
    }

    .mint-popup-3 {
      width: 6.13333333rem;
      height: 100%;

      .rightFliterBox {
        overflow: auto;
        width: 6.13333333rem;
        height: 100%;
        box-shadow: none;
        top: 0;
        background-color: #fff;
        transition: right 0.5s ease-in-out;
        box-shadow: 0 .02666667rem .4rem #0006;

        .filter_title {
          width: 100%;
          height: 1.2rem;

          .title {
            float: left;
            line-height: 1.2rem;
            font-size: 0.4rem;
            margin-left: 0.4rem;
          }

          .mint-button {
            float: right;
            height: 100%;
            background: #fff;
            box-shadow: none;

            .icon-cuowu {
              float: right;
              margin-right: 0.0267rem;
              line-height: 1.2rem;
              font-size: 0.4rem;
            }
          }
        }

        .fliter_item {
          margin-top: 0.4rem;
          padding: 0 0.26666667rem;

          &:nth-last-of-type(2) .category_list {
            border-bottom: 1.33333333rem solid #fff;
            /*padding-bottom: 1.33333333rem;*/
          }

          .category_name {
            height: 0.33333333rem;
            margin: 0 0.26666667rem 0.06666667rem;

            span {
              font-size: 0.26666667rem;
              color: #9B9B9B;
            }

            .showCategory {
              float: right;
              color: #606060;
              font-size: 0.26666667rem;

              .iconfont {
                margin-left: 5px;
                font-size: 0.26666667rem;
                transition: all 0.2s linear;
                display: inline-block;

                &.open {
                  transform: rotate(180deg);
                }
              }
            }
          }

          .category_list {
            padding: 0.26666667rem 0 0.12rem;
            border-bottom: 0.02666667rem solid #efefef;

            .option {
              font-size: 0.33333333rem;
              width: 1.6rem;
              margin: 0px 0.13333333rem 0.26666667rem;
              float: left;
              border-radius: 0.10666667rem;
              background-color: #efefef;
              color: #606060;
              text-align: center;
              line-height: 0.69333333rem;
              overflow: hidden;
              height: 0.69333333rem;
            }

            & .checked {
              background-color: #f98f3c;
              color: #fff !important;
            }

            &.twocol {
              height: 2.6667rem;
              overflow: hidden;
              width: 100%;

              &.show {
                height: auto;
              }

              .option {
                width: 2.53333333rem;
                color: #333333;
              }
            }
          }
        }

        .bottom_f {
          position: fixed;
          width: 100%;
          bottom: 0;
          height: 1.2rem;
          padding: 0.26666667rem 0;
          box-sizing: border-box;
          color: #fff;
          background-color: -webkit-linear-gradient(to left, #ff5a51, #ffa500);
          background-color: -o-linear-gradient(to left, #ff5a51, #ffa500);
          background-image: linear-gradient(to left, #ff5a51, #ffa500);

          .reset {
            float: left;
            text-align: center;
            font-size: 0.42666667rem;
            line-height: 0.66666667rem;
            height: 0.66666667rem;
            width: 50%;
            box-sizing: border-box;
            border-right: 0.02666667rem solid #fff;
          }

          .success {
            float: left;
            width: 50%;
            line-height: 0.66666667rem;
            height: 0.66666667rem;
            text-align: center;
            font-size: 0.42666667rem;
          }
        }
      }
    }

    .fboot {
      height: 1rem;
      display: block;
    }

    .mint-loadmore {
      position: absolute;
      top: 0px;
      bottom: 40px;
      width: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .mint-loadmore-top {
      font-size: 0.42rem;
      color: #606060;
    }

    .checkOutPop {
      width: 100%;
      height: 60%;
      margin-top: 40%;
      background: #fff;

      .checkList {
        width: 90%;
        height: 40px;
        padding: 5px 10px;
        text-align: left;
        line-height: 40px;
        margin: 0 auto;
        border-bottom: 1px dashed #efefef;
        position: relative;
        word-break: break-all;
        font-size: 14px;

        &.mutlList {
          height: auto;
          max-height: 120px;
          overflow-y: auto;
        }

        //       overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        label {
          height: 40px;
          line-height: 40px;
          width: 60px;
          float: left;
          font-size: 16px;
        }
      }

      .ooreason {
        width: 5rem;
        height: 0.8rem;
        margin-top: 0.08rem;
        border: 1px solid #ccc;

        line-height: 0.64rem;
      }

      .popBottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        height: 45px;
        background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

        .cCancle,
        .cSure {
          float: left;
          height: 100%;
          width: 50%;
          color: #fff;
          font-size: 16px;
          box-sizing: border-box;
          border-right: 2px solid #fff;
          text-align: center;
          line-height: 45px;
        }

        .cSrue {
          border-right: none;
        }
      }
    }

    .pos {
      //   z-index:101 !important;
      height: 60%;
      font-size: 14px;

      .checkList {
        font-size: 14px;
        height: 35px;

        label {
          width: 100px;
        }
      }
    }

    .bgnothing {
      text-align: center;
      margin-top: 5.9333rem;
    }

    // 超大模式
    &.fuckingBig {
      .foot_ft {
        box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
        width: 100%;
        position: absolute;
        bottom: 1.1733rem;
        padding: 0 0.18666667rem;
        box-sizing: border-box;

        .footPop {
          width: ~"calc(100% - .9rem)";
          left: ~"calc(50% - .5rem)";
          box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
          opacity: 1;
        }

        .foot_c {
          display: block;
          width: 100%;
          background-color: #fff;
          border-bottom: 1px solid #ddd;
          padding: 0.16rem 0;
          box-sizing: border-box;
          overflow-y: hidden;
          overflow-x: auto;

          .top {
            margin-top: 0.1rem; // margin-left: 0.36rem;
            margin-right: 0.15rem;
            float: left;
            text-align: left;
            color: #333; // padding: 0.05333333rem 0;
            padding: 0.1rem 0.1867rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            font-size: 0.5rem;

            .cicle {
              width: 0.4rem;
              height: 0.4rem;
              margin-right: 0.08rem;
              margin-top: -0.04rem;
              float: left;
              border-radius: 50%;
              border: 1px solid #969696;
              vertical-align: middle;
              position: relative;

              .iconfont {
                text-align: center;
                line-height: 0.30rem;
                vertical-align: text-top;
                font-size: 0.30rem;
                color: #333;
              }

            }
          }

          .checked {
            background: #f98f3c;
            border-radius: 0.26666667rem;
            padding: 0.1rem 0.1867rem;
            color: #fff;

            .cicle {
              border: none;
              background: #52c3f3; //   border: 1px solid #969696;
              margin-top: 0px;
            }
          }
        }

        .foot_d {
          background-color: #fff;
          width: 100%;
          padding: 0.16rem 0;
        }

        .flotwarp {
          .bottom {
            margin: 5px 0;
            float: left;
            height: 100%;
            color: #333;
            box-sizing: border-box;
            -webkit-tap-highlight-color: transparent;
            -webkit-user-select: none;
            -moz-user-focus: none;
            -moz-user-select: none;
            font-size: 0.5rem;
            width: 33%;

            .checkbox {
              display: inline-block;
              text-align: center;
              padding: 0.1rem;
              box-sizing: border-box;

              &.checked {
                background: #f98f3c;
                border-radius: 0.26666667rem;
                color: #fff;
              }

              .dimetric {
                width: 0.4rem;
                height: 0.4rem;
                margin-right: 0.08rem;
                float: left;
                border-radius: 0.1rem;
                border: 1px solid #969696;
                margin-top: 0.12rem;
                background: #fff;
                position: relative;

                .iconfont {
                  color: #333;
                  text-align: center;
                  line-height: 0.30rem;
                  vertical-align: text-top;
                  font-size: 0.30rem;
                }
              }
            }

            .change {
              width: 33.3%;
            }
          }
        }
      }

      .mint-popup-3 {
        width: 90%;
        height: 100%;

        .rightFliterBox {
          overflow: auto;
          width: 100%;
          height: 100%;
          top: 0;
          background-color: #fff;
          transition: right 0.5s ease-in-out;
          box-shadow: 0 .02666667rem .4rem #0006;
          padding-bottom: 50px;
          box-sizing: border-box;

          .filter_title {
            width: 100%;
            height: 1.6rem;

            .title {
              float: left;
              line-height: 1.5rem;
              font-size: 0.6rem;
              margin-left: 0.4rem;
            }

            .mint-button {
              float: right;
              height: 100%;
              background: #fff;
              box-shadow: none;

              .icon-cuowu {
                float: right;
                margin-right: 0.0267rem;
                line-height: 1.2rem;
                font-size: 0.7rem;
              }
            }
          }

          .fliter_item {
            margin-top: 0.4rem;
            padding: 0 0.26666667rem;

            &:nth-last-of-type(2) .category_list {
              border-bottom: 1.33333333rem solid #fff;
              /*padding-bottom: 1.33333333rem;*/
            }

            .category_name {
              height: 0.8rem;
              margin: 0 0.26666667rem 0.06666667rem;

              span {
                font-size: 0.7rem;
                color: #9B9B9B;
              }

              .showCategory {
                float: right;
                color: #606060;
                font-size: 0.6rem;

                .iconfont {
                  margin-left: 0px;
                  font-size: 0.5rem;
                  transition: all 0.2s linear;
                  display: inline-block;

                  &.open {
                    transform: rotate(180deg);
                  }
                }
              }
            }

            .category_list {
              padding: 0.26666667rem 0 0.12rem;
              border-bottom: 0.02666667rem solid #efefef;

              .option {
                font-size: 0.5rem;
                width: 2rem;
                margin: 0px 0.13333333rem 0.26666667rem;
                float: left;
                border-radius: 0.10666667rem;
                background-color: #efefef;
                color: #606060;
                text-align: center;
                line-height:1.2rem;
                overflow: hidden;
                height: 1.2rem;
              }

              & .checked {
                background-color: #f98f3c;
                color: #fff !important;
              }

              &.twocol {
                height: 4.6667rem;
                overflow: hidden;
                width: 100%;

                &.show {
                  height: auto;
                }

                .option {
                  width: 3.53333333rem;
                  color: #333333;
                }
              }
            }
          }

          .bottom_f {
            position: fixed;
            width: 100%;
            bottom: 0;
            height: 1.5rem;
            box-sizing: border-box;
            padding: 0;
            color: #fff;
            background-color: -webkit-linear-gradient(to left, #ff5a51, #ffa500);
            background-color: -o-linear-gradient(to left, #ff5a51, #ffa500);
            background-image: linear-gradient(to left, #ff5a51, #ffa500);

            .reset {
              float: left;
              text-align: center;
              font-size: 0.6rem;
              line-height: 1.5rem;
              height: 1.5rem;
              width: 50%;
              box-sizing: border-box;
              border-right: 1px solid #fff;
            }

            .success {
              float: left;
              width: 50%;
              line-height: 1.5rem;
              height: 1.5rem;
              text-align: center;
              font-size: 0.6rem;
            }
          }
        }
      }

      .fangt_top {
        .search {
          margin-left: 0.14rem;
          border-radius: 0.44rem;
          width: 6.1rem;
          float: left;
          height: 0.85333333rem;
          background-color: #f7f8fa;
          padding: 0 0.26666667rem;
          overflow: hidden;
          box-sizing: border-box;
          font-size: 18px;
          display: flex;
          align-items: center;
          i.icon-sousuo {
            vertical-align: bottom;
            font-size: 0.6rem;
            color: #ccc;
            line-height: 0.89333333rem;
          }

          input {
            padding-left: 0.2rem;
            width: 3.28rem;
            vertical-align: middle;
            //margin-bottom: 0.13333rem;
            flex: 1;
            height: 0.62666667rem;
            background-color: #f7f8fa;
            outline: 0;
            border: 0;
          }

          .cleartext {
            float: right;

            i.icon-cuowu {
              line-height: 0.5rem;
              background-color: #c3c3c3;
              border-radius: 50%;
              font-size: 0.5rem;
              text-align: center;
              color: #fff;
              padding: 0.13333333rem;
              margin-top: 0rem;
              -webkit-transform-origin-x: 0;
              transform: scale(0.6);
              -webkit-transform: scale(0.6);
              width: 0.5rem;
              height: 0.5rem;
              display: inline-block;
            }

            i.icon-yuyin {
              line-height: 0.85333333rem;
              font-size: 0.7rem;
              color: #999;
              text-align: center;
              padding-right: 0.13333333rem;
              display: inline-block;
            }
          }
        }

        .searct_btn {
          width: 1.73333333rem;
          box-sizing: border-box;
          text-align: left;
          float: left;
          height: 100%;
          font-size: 0.5rem;
          line-height: 0.89333333rem;
          color: #5b5b5b;
          padding-left: 0.33333333rem;
        }

        .line {
          float: left;
          width: 0.02666667rem;
          height: 0.53333333rem;
          background-color: #ccc;
          margin-top: 0.21333333rem;
        }

        .mint-button {
          height: 100%;
          background: #fff;
          box-shadow: none;
          padding: 0;

          .fliter {
            width: 1.86666667rem;
            float: left;
            font-size: 0.5rem;
            line-height: 0.89333333rem;
            text-align: right;
            box-sizing: border-box;
            color: #5b5b5b;

            .iconfont {
              display: inline-block;
              margin-left: 0rem;
            }
          }
        }
      }
      .bind-title {
        font-size: 22px;
      }
      .bind-build-list {
        padding: 15px 5%;
        box-sizing: border-box;
        text-align: center;

        .bind-build-item {
          display: inline-block;
          border: 1px solid #ddd;
          padding: 8px 20px;
          box-sizing: border-box;
          border-radius: 5px;
          margin-bottom: 10px;
          text-align: center;
          width: 25%;
          margin-right: 5px;
          font-size: 20px;

          &:nth-child(3n) {
            margin-right: 0;
          }

          &:active {
            background: #ddd;
          }

          &.active {
            background: orange;
            border: 1px solid orange;
          }
        }
      }

      .building-bar {
        height: 1.3rem;
        background: #eee;
        box-sizing: border-box;
        position: fixed;
        top: 2.3rem;
        left: 0;
        z-index: 999;
        width: 100%;
        overflow-x: scroll;
        white-space: nowrap;

        .building-bar-item {
          display: inline-block;
          height: 1.3rem;
          line-height: 1.3rem;
          padding: 0 20px;
          text-align: center;
          border-right: 1px solid #fff;
          box-sizing: border-box;
          min-width: 19%;
          font-size: 16px;
          &.active {
            color: #4697fe;
            border-bottom: 3px solid #4697fe;
          }
        }
      }

      .occ-num-list {
        padding-left: 8px;
        font-size: 0;

        .iconfont {
          font-size: 18px;
          color: #333;
          display: inline-block;
        }
      }

      .all_ft {
        width: 100%;
        margin-top: 3.7rem;
        padding-bottom: 4.5rem;

        &.mt-small {
          margin-top: 1.1rem;
        }

        .fcolor {
          .roomNo,
          .roomType {
            color: #000 !important;
          }
        }

        .roomListItem {
          width: 33.33%;
          height: 3.2rem;
          position: relative;
          background: #aaa;
          top: 0.02666667rem;
          float: left;
          border-bottom: 1px solid #fff;
          box-sizing: border-box;
          overflow: hidden;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          padding-top: 15px;

          .icon-mima {
            position: absolute;
            top: 10px;
            left: 4px;
            font-size: 18px;
          }

          .roomNo {
            font-size: 0.55rem;
            height: 0.55rem;
            line-height: 0.55rem;
          }

          .roomType {
            box-sizing: border-box;
            padding: 0 0.06666667rem;
            font-size: 1.4rem;
            line-height: 1.3rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .rms {
            font-size: 0.45rem
          }

          .multChoice {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, .3);

            .mult-cicle {
              display: none;
              position: absolute;
              border-radius: 50%; // border: 1px #f7f8fa solid;
              box-sizing: border-box; // background: rgba(249, 143, 66, 0.4);
              background: #1470df;
              right: 7px; // left: 0;
              bottom: 7px; // margin: ~"calc(50% - 10px)" auto 0;
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
            }

            &.choiced {
              background-color: rgba(0, 0, 0, 0);

              .mult-cicle {
                display: block;

                .iconfont {
                  text-align: center;
                  line-height: 30px;
                  color: #fff;
                  font-size: 20px;
                }
              }
            }

            &.deepBg {
              background-color: rgba(0, 0, 0, 0.6);
            }
          }
        }
      }

      .roomFloorList {
        display: inline-block;
        width: 100%;
        border-bottom: 1px solid #eee;

        .room-floor-header {
          color: #b2b5c0;
          padding: 12px 15px;
          font-size: 20px;
        }

        .room-item {
          width: 2rem;
          height: 2rem;
          position: relative;
          top: 0.02666667rem;
          float: left;
          background: #caaf61;

          .item {
            border-bottom: 1px solid #fff;
            box-sizing: border-box;
            height: 100%;
            width: 100%;
            background-color: #00cfcf;
            overflow: hidden;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            position: relative;

            &.rightBorder {
              border-right: 1px solid #fff;
            }

            p {
              text-align: center;
              color: #333;
              margin: 0;
            }

            .roomNo {
              font-size: 0.32rem;
              height: 0.6rem;
              line-height: 0.6rem;
            }

            .roomType {
              box-sizing: border-box;
              padding: 0 0.06666667rem;
              font-size: 0.33333333rem;
              line-height: 0.66666667rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .rms {
              font-size: 0.25rem
            }

            .multChoice {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              background-color: rgba(0, 0, 0, .3);

              .mult-cicle {
                display: none;
                position: absolute;
                border-radius: 50%; // border: 1px #f7f8fa solid;
                box-sizing: border-box; // background: rgba(249, 143, 66, 0.4);
                background: #1470df;
                right: 7px; // left: 0;
                // top: 0;
                bottom: 7px; // margin: ~"calc(50% - 10px)" auto 0;
                width: 20px;
                height: 20px;
                text-align: center;
              }

              &.choiced {
                background-color: rgba(0, 0, 0, 0);

                .mult-cicle {
                  display: block;

                  .iconfont {
                    text-align: center;
                    line-height: 20px;
                    color: #fff;
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// fangTHuanQiu.vue?2bb8c42e